import { render, staticRenderFns } from "./WebPartSlickerImageDesigner.vue?vue&type=template&id=2f981bfb&scoped=true&"
import script from "./WebPartSlickerImageDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartSlickerImageDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartSlickerImageDesigner.vue?vue&type=style&index=0&id=2f981bfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f981bfb",
  null
  
)

export default component.exports